import { render, staticRenderFns } from "./UploadManagerOverlay.vue?vue&type=template&id=4b66ddc2"
import script from "./UploadManagerOverlay.vue?vue&type=script&lang=js"
export * from "./UploadManagerOverlay.vue?vue&type=script&lang=js"
import style0 from "./UploadManagerOverlay.vue?vue&type=style&index=0&id=4b66ddc2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports